module.exports = __webpack_public_path__ + "static/media/VKFest_main_t.7a6d938e.jpg";